export function toDateString(dateString: string | null): string | undefined {
  if (dateString === null) {
    return undefined
  }
  try {
    return new Date(dateString).toISOString()
  } catch {
    return undefined
  }
}
